// extracted by mini-css-extract-plugin
export default {"customCheckbox":"style_customCheckbox__qT6zj","label":"style_label__ICniK","checked":"style_checked__zJMIS","spanFirst":"style_spanFirst__JxzOv"};